module.exports = __webpack_public_path__ + "static/media/img-qc.54ca9ec7.png";